<!--
   Created by qing on 2021/1/23
   Des: 
-->
<template>
  <div>
    <van-cell class="ry-form__member"  v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if=" ((current.value.member && current.value.member.length)
        || (current.value.external && current.value.external.length))">
          <ContactView
            :member="current.value.member"
            :external="current.value.external">
          </ContactView>
        </div>

        <div
          v-if="(!current.value.member || !current.value.member.length)
        && (!current.value.external || !current.value.external.length)">
          暂无内容
        </div>
      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__member-compact">

      <van-field
        :label="current.title"
        :label-class="{'readonly-field-label': !isRead && isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div
            v-if="((current.value.member && current.value.member.length)
        || (current.value.external && current.value.external.length))">
            <ContactView
              :member="current.value.member"
              :external="current.value.external">
            </ContactView>
          </div>

          <div
            v-if="(!current.value.member || !current.value.member.length)
        && (!current.value.external || !current.value.external.length)">
            暂无内容
          </div>
        </template>
      </van-field>
    </div>
  </div>
</template>

<script>
  import ContactView from "./component/ContactView"
  import { current } from './mixin'
  export default {
    mixins: [current],
    components: {
      ContactView
    },
    data () {
      return {
      }
    },
    computed: {},
    methods: {
    },
    watch: {}
  }
</script>